import { PageName } from '@/enums/pageName'
import { downloadImage } from '@/utils/imageUtils'

import { TextHTML } from '@/components/typography'
import { weeksGraph } from '@/shared/images/organic-fit'

import { TWeightLossTimelineChartProps } from './types'

const imageSrc = downloadImage(weeksGraph)

export const WeightLossTimelineChart = ({
  getItem,
  period,
  chartName,
  yourWeightText,
  yourWeightGoalText,
  descriptionPlan,
}: TWeightLossTimelineChartProps) => {
  const weight = getItem(PageName.weight)
  const goal = getItem(PageName.weightGoal)

  const currentWeight = weight ? JSON.parse(weight) : undefined
  const weightGoal = goal ? JSON.parse(goal) : undefined

  const yourWeight = `${currentWeight?.value} ${currentWeight?.measurementSystem}`
  const yourWeightGoal = `${weightGoal?.value} ${weightGoal?.measurementSystem}`
  const yourWeightInterim = `${Math.round(
    parseInt(yourWeight) - 0.5 * (parseInt(yourWeight) - parseInt(yourWeightGoal))
  )} ${currentWeight?.measurementSystem}`

  return (
    <div className="graph-wrapper">
      <div className="graph-name">{chartName || 'Your weight'}</div>
      <div className="graph-logo">
        <div className="img-wrapper">
          <img src={imageSrc.src} alt="graph" />
        </div>
        <TextHTML className="current-weight" title={yourWeightText || yourWeight} />
        {!(yourWeightText && yourWeightGoalText) && (
          <div className="intermediate-weight">{yourWeightInterim}</div>
        )}
        <TextHTML className="goal-weight" title={yourWeightGoalText || yourWeightGoal} />
      </div>
      <div className="periods">
        {Array.from({ length: 4 }, (_, i) => (
          <div key={i} className="label">
            <span> {period || 'week'}</span>
            <span className="space">&nbsp;</span>
            <span>{i + 1}</span>
          </div>
        ))}
      </div>
      <div className="description-plan">
        {descriptionPlan || 'This chart is for illustrative purposes only'}
      </div>
    </div>
  )
}
